import React from "react";
import { motion } from "framer-motion";

const InfiniteScroll = ({ partners }) => {
  // Duplicate the list to create a seamless effect
  const duplicatedPartners = [...partners, ...partners];

  return (
    <div className="w-full my-5 flex flex-col items-center justify-center h-full">
      <div className="space-y-5 w-full">
        <div className="relative w-full">
          <motion.div
            className="flex w-max gap-10 h-40 items-center"
            animate={{ x: ["0%", "-50%"] }}
            transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
          >
            {duplicatedPartners.map((partner, index) => (
              <div key={`row1-${index}`} className="w-72 h-96 flex items-center justify-center">
                {/* <div key={`row1-${index}`} className="w-80 h-32 flex items-center justify-center bg-gray-50 rounded-lg shadow-xl"></div> */}
                <img src={partner.logo} alt={partner.name} className="h-24 object-contain" />
              </div>
            ))}
          </motion.div>
        </div>

        {/* <div className="relative w-full">
          <motion.div
            className="flex w-max gap-10 h-40 items-center"
            animate={{ x: ["-50%", "0%"] }} 
            transition={{ repeat: Infinity, duration: 80, ease: "linear" }}
          >
            {duplicatedPartners.map((partner, index) => (
              <div key={`row2-${index}`} className="w-80 h-32 flex items-center justify-center bg-gray-50 rounded-lg shadow-xl">
                <img src={partner.logo} alt={partner.name} className="h-20 object-contain" />
              </div>
            ))}
          </motion.div>
        </div> */}
      </div>
    </div>
  );
};

export default InfiniteScroll;
